import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCA from "./locales/en-CA.json";
import frCA from "./locales/fr-CA.json";

import helmetEN from "./locales/helmet-en.json";
import helmetFR from "./locales/helmet-fr.json";

import { getSavedLang, getLangFromUrl, isQcByCookie } from "../utils/lang";
const initialLang = getLangFromUrl() || getSavedLang() || (isQcByCookie() ? "fr" : "en");

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enCA,
        helmet: helmetEN,
      },
      fr: {
        translation: frCA,
        helmet: helmetFR,
      },
    },
    lng: initialLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
